import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './ServicePages.css';
import { fadeInUp } from '../constants/animations';

function Rewards() {
  return (
    <main className="service-page">
      <div className="service-container">
        <motion.div className="service-hero" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.25 }}>
          <motion.h1 variants={fadeInUp} custom={0}>Rewards Program</motion.h1>
          <motion.p variants={fadeInUp} custom={1}>Turn satisfied customers into repeat clients and referral sources automatically.</motion.p>
        </motion.div>

        <div className="service-section">
          <motion.div className="service-feature" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={0}>
            <h4>Referral boosts</h4>
            <p>Encourage word‑of‑mouth growth with incentives.</p>
          </motion.div>
          <motion.div className="service-feature" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={1}>
            <h4>Repeat business</h4>
            <p>Trigger follow‑ups that keep customers coming back.</p>
          </motion.div>
          <motion.div className="service-feature" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={2}>
            <h4>Automated campaigns</h4>
            <p>Set it once and let the program run.</p>
          </motion.div>
        </div>

        <motion.div className="service-block" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.25 }} variants={fadeInUp} custom={0}>
          <h3>What you get</h3>
          <ul className="service-list">
            <li>Branded rewards experience</li>
            <li>Referral tracking and incentives</li>
            <li>Automated follow‑ups</li>
            <li>Simple reporting</li>
          </ul>
        </motion.div>

        <div className="service-split">
          <motion.div className="service-split-card" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={0}>
            <h4>Who it’s for</h4>
            <p>Local businesses with repeat customers and referral potential.</p>
          </motion.div>
          <motion.div className="service-split-card" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={1}>
            <h4>Plug‑and‑play</h4>
            <p>We configure it for you and connect it to your site.</p>
          </motion.div>
        </div>

        <motion.div className="service-cta" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.35 }} variants={fadeInUp} custom={0}>
          <Link to="/plans">Get Started</Link>
        </motion.div>
      </div>
    </main>
  );
}

export default Rewards;
